function buildUrl(url, options) {
  return (options == null ? void 0 : options.previewMode) ? `${process.env["PM2_PREVIEW_API"]}${url}` : `${process.env["PM2_API"]}${url}`;
}

export { buildUrl };
//# sourceMappingURL=util.build-url.js.map
